module.exports = __webpack_public_path__ + "static/tennis-0d20eaddb4ab153aff917cb3be0ce7f2.svg";